import { Link } from "@inertiajs/react";
import AllPromptAnswers from "components/prompts/PromptAnswers";
import PinPromptButton from "features/prompts/components/PinPromptButton";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import { PromptSerializersPromptUser } from "types/serializers";

export default function PromptAnswersPage({
  prompt,
}: {
  prompt: PromptSerializersPromptUser;
}) {
  const currentUserId = useCurrentUserId();

  return (
    <div>
      <div className="grid sm:grid-cols-12 mx-2 gap-8">
        <div className="sm:col-span-9">
          <p className="mt-4">
            <Link
              href={`/prompts/${prompt.slug}`}
              className="text-2xl font-bold mt-2 hover:underline"
            >
              {prompt.question}
            </Link>

            <Link
              href={`/prompts/${prompt.slug}/answer`}
              className="ml-2 rounded-sm px-1 py-0.5 text-sm bg-yellow-400 dark:text-gray-800 font-semibold hover:bg-yellow-300"
            >
              Answer
            </Link>
          </p>

          <div className="flex gap-4 flex-wrap mt-4 items-center">
            {currentUserId === prompt.userId ? (
              <Link
                href={`/prompts/${prompt.slug}/edit`}
                className="font-semibold text-gray-700 dark:text-gray-400 text-sm hover:underline"
              >
                Edit Prompt
              </Link>
            ) : (
              false
            )}
            {currentUserId ? (
              <PinPromptButton promptId={prompt.id} />
            ) : (
              false
            )}
            {currentUserId ? (
              <Link
                href={`/prompts/${prompt.slug}/answer`}
                className="font-semibold text-gray-700 dark:text-gray-400 text-sm hover:underline"
              >
                Edit Your Answers
              </Link>
            ) : (
              false
            )}
          </div>

          <div className="my-4">
            <p>{prompt.description}</p>
          </div>
        </div>
      </div>
      <div>
        <div />
        <AllPromptAnswers answers={prompt.promptBooks} />
      </div>
    </div>
  );
}
